export const getSearchParams = (getter) => {
  let searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(getter);
};
